import { render, staticRenderFns } from "./MiniCard.vue?vue&type=template&id=b621a5d8&scoped=true"
import script from "./MiniCard.vue?vue&type=script&lang=js"
export * from "./MiniCard.vue?vue&type=script&lang=js"
import style0 from "./MiniCard.vue?vue&type=style&index=0&id=b621a5d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b621a5d8",
  null
  
)

export default component.exports